import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { IoMdArrowRoundDown, IoMdArrowRoundUp } from "react-icons/io";
import { FiPlus, FiSearch, FiEdit2 } from "react-icons/fi";
import { RiDeleteBinLine } from "react-icons/ri";
import { BsThreeDotsVertical } from "react-icons/bs";
import { GoFilter } from "react-icons/go";
import {
  useGetAllProductsQuery,
  useDeleteProductMutation,
} from "../redux/services/products";
import { useGetAllUsersQuery } from "../redux/services/profile";
import { useGetAllCategoriesQuery } from "../redux/services/categories";
import { useGetAllProductTypeQuery } from "../redux/services/product_type";
import toggleOn from "../assets/icons/toggle-on-icon.svg";
import toggleOff from "../assets/icons/toggle-off-icon.svg";
import Pagination from "./pagination";
import { createClient } from "../utils/supbase/client";
import { useGetOrdersQuery, useUpdateOrderMutation } from "../redux/services/orders";
import { useSelector } from "react-redux";

const OrderListingTable = () => {
  const supabase = createClient();
  const [sortOrder, setSortOrder] = useState("asc");
  const [searchQuery, setSearchQuery] = useState("");
  const [modal, setModal] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const pageLimit = 10;
  const offset = (pageNumber - 1) * pageLimit;
  const [filteredOrders, setFilteredOrders] = useState();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const navigate = useNavigate();

  const user = useSelector((state) => state.auth.user);

  const [updateOrder, { data: updatedProduct, isLoading: updating }] =
  useUpdateOrderMutation();

  const {
    data: orders,
    error,
    isFetching: isLoading,
  } = useGetOrdersQuery({
    user_id: user.id,
    offset: offset,
    pageLimit: pageLimit,
  });

  const handlePageChange = (page) => {
    setPageNumber(page);
  };

  const handleSearch = (e) => setSearchQuery(e.target.value.toLowerCase());

  useEffect(() => {
    if (orders) {
      setFilteredOrders(
        orders?.filter(
          (order) => order?.name.toLowerCase().includes(searchQuery)
            || order?.status.toLowerCase().split('_').join(' ').includes(searchQuery)
            || order?.product_details.some(product => product.product_name.toLowerCase().includes(searchQuery))
          // || user?.email.toLowerCase().includes(searchQuery)
        ) || []
      );
    }
  }, [orders, searchQuery]);

  const handleStatusChange = async (e, id) => {
    const newStatus = e.target.value;

    await updateOrder({
      id: id,
      status: newStatus,});
  };
  

  return (
    <div className="container mx-auto py-4 px-0">
      <div className="flex justify-between items-center mb-4 gap-2">
        <div className="relative md:w-[464px]">
          <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#9D9EA1]" />
          <input
            type="text"
            placeholder="Search"
            value={searchQuery}
            className="border px-10 py-1 rounded-lg w-full h-[48px] bg-[#F1F3F9] placeholder-[#9D9EA1]"
            onChange={handleSearch}
          />
        </div>
      </div>

      <div className="md:overflow-visible md:max-h-none overflow-y-auto max-h-[400px]">
        <table className="min-w-full border-separate border border-[#F1F3F9] rounded-lg border-spacing-y-0">
          <thead className="bg-[#F9FAFB]">
            <tr className="border-b border-[#F1F3F9] text-[#484E5A] text-sm">
              <th className="p-2 text-left">Order Name</th>
              <th className="p-2 text-left">Buyer Name</th>
              <th className="p-2 text-left">Buyer Address</th>
              <th className="p-2 text-left">Email</th>
              <th className="p-2 text-left">Phone Number</th>
              <th className="p-2 text-left">Order Details</th>
              <th className="p-2 text-left">Total Price</th>
              <th className="p-2 text-left">Status</th>
            </tr>
          </thead>
          <tbody>
            {filteredOrders?.length === 0 ? (
              <tr>
                <td colSpan="100%">
                  <div className="flex justify-center items-center py-4 text-gray-500">
                    No data found
                  </div>
                </td>
              </tr>
            ) : (
              filteredOrders?.slice(offset, offset + pageLimit).map((item) => (
                <tr key={item.id} className="border-b border-[#F1F3F9] text-sm">
                  <td className="p-2">{item?.id}</td>
                  <td className="p-2">{item?.name}</td>
                  <td className="p-2">
                    {item?.billing_address} {item?.state} , {item?.country}{" "}
                    {item?.zip_code}{" "}
                  </td>
                  <td className="p-2">{item?.email}</td>
                  <td className="p-2">{item?.phone}</td>
                  <td className="p-2">
                    {item.product_details.map((product) => (
                      <div
                        key={product.product_id}
                        className=" flex flex-row justify-between text-nowrap gap-3"
                      >
                        <div>
                          {product.product_name}
                          <sup>{product.quantity}</sup>
                        </div>
                        <div> $ {product.product_price}</div>
                      </div>
                    ))}
                  </td>
                  <td className="p-2">$ {item?.total_amount}</td>
                  <td className="p-2">
                    <select
                      // className="form-select"
                      value={item?.status}
                      onChange={(e) => handleStatusChange(e, item.id)}
                    >
                      <option value="pending">Pending</option>
                      <option value="in_progress">In Progress</option>
                      <option value="delivered">Delivered</option>
                      <option value="cancelled">Cancelled</option>
                    </select>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <Pagination
        currentPage={pageNumber}
        totalItems={filteredOrders?.length}
        itemsPerPage={pageLimit}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default OrderListingTable;
